/* global firebase */
import Vue from "vue";
import App from "./App.vue";
//import Splash from "./views/Splash";

import "./registerServiceWorker";
import router from "./router";
import store from "./store/store";
import vuetify from "./plugins/vuetify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import vue_resource from "vue-resource";

Vue.config.productionTip = false;

firebase.firestore().enablePersistence({ synchronizeTabs: true });

firebase.auth().onAuthStateChanged(user => {
  store.commit("user/SET_AUTH_PROFILE", user);
  if (user) store.commit("user/LOGIN");
  else store.commit("user/LOGOUT");
  store.dispatch("user/load_profile", user);
  new Vue({
    vue_resource,
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount("#app");
});
